// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	AddButton: 'add-button',
	DialogButton: 'dialog-button',
	DeleteButton: 'delete-button',
	SortButton: 'sort-button',
	DatePicker: 'date-picker',
	DropdownOptions: 'dropdown-options',
	BalanceDueOnClosing: 'balance-due-on-closing',
	MessageBar: 'message-bar',
	OverrideSwitch: 'override-switch',
	DateToClosingSpan: 'date-to-closing-span',
	Title: 'title',
} as const;
